import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/internal/Observable';

import { AiConversation, AiConversationFilters } from '@app/models';


export interface AiConversationSearch {
  filters: AiConversationFilters;
  pageIndex: number;
  pageSize: number;
  sortField: string;
  sortDirection: 'asc' | 'desc';
}


@Injectable({ providedIn: 'root' })
export class AiConversationService {
  private _apiRoute = '/api/ai-conversations/';
  private headerOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

  // Last grid search + its page of rows, so the profile's prev/next walks the same list (template-profile pattern).
  currentSearch: { params: AiConversationSearch; results: { rows: AiConversation[]; total: number } } = null;


  constructor(
    private httpClient: HttpClient
  ) { }


  search(_search: AiConversationSearch): Observable<{ rows: AiConversation[]; total: number }> {
    const _body = { ..._search, filters: this.toServerFilters(_search?.filters) };
    return this.httpClient.post<{ rows: AiConversation[]; total: number }>(this._apiRoute + 'search', JSON.stringify(_body), this.headerOptions);
  }


  get(_id: string): Observable<AiConversation> {
    return this.httpClient.get<AiConversation>(this._apiRoute + _id);
  }


  getOutcomes(): Observable<string[]> {
    return this.httpClient.get<string[]>(this._apiRoute + 'outcomes');
  }


  // Pass ids to export just those, or filters (no ids) to export everything matching.
  exportRows(_body: { ids?: string[]; filters?: AiConversationFilters; sortField?: string; sortDirection?: string }): Observable<{ rows: any[]; total: number; capped: boolean }> {
    const _sendBody = { ..._body, filters: this.toServerFilters(_body?.filters) };
    return this.httpClient.post<{ rows: any[]; total: number; capped: boolean }>(this._apiRoute + 'export', JSON.stringify(_sendBody), this.headerOptions);
  }


  deleteMany(_ids: string[]): Observable<{ deleted: number }> {
    return this.httpClient.post<{ deleted: number }>(this._apiRoute + 'delete', JSON.stringify({ ids: _ids }), this.headerOptions);
  }


  // The date inputs are whole local days. Send the start of From and the end of To so both days are included.
  private toServerFilters(_filters: AiConversationFilters): AiConversationFilters {
    const _out: AiConversationFilters = { ...(_filters ?? {}) };
    if (_filters?.dateFrom) _out.dateFrom = new Date(_filters.dateFrom + 'T00:00:00').toISOString();
    if (_filters?.dateTo) _out.dateTo = new Date(_filters.dateTo + 'T23:59:59.999').toISOString();
    return _out;
  }
}
